import { IDiagnosticsService } from './services/interfaces';

/**
 * A base class for components that are indifferent to
 * whether or not the current user is authenticated.
 */
export abstract class LoginUnawareComponent {
  public isIframe: boolean;

  constructor(protected diagnostics: IDiagnosticsService) {
    this.isIframe = window !== window.parent && !window.opener;
  }
}
